// source: device_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var iridium_account_proto_pb = require('./iridium_account_proto_pb.js');
goog.object.extend(proto, iridium_account_proto_pb);
var timestamp_proto_pb = require('./timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
var user_proto_pb = require('./user_proto_pb.js');
goog.object.extend(proto, user_proto_pb);
var peripheral_proto_pb = require('./peripheral_proto_pb.js');
goog.object.extend(proto, peripheral_proto_pb);
var command_public_proto_pb = require('./command_public_proto_pb.js');
goog.object.extend(proto, command_public_proto_pb);
var device_record_proto_pb = require('./device_record_proto_pb.js');
goog.object.extend(proto, device_record_proto_pb);
var command_proto_pb = require('./command_proto_pb.js');
goog.object.extend(proto, command_proto_pb);
var primitive_proto_pb = require('./primitive_proto_pb.js');
goog.object.extend(proto, primitive_proto_pb);
goog.exportSymbol('proto.DeviceDto', null, global);
goog.exportSymbol('proto.DeviceEventResponse', null, global);
goog.exportSymbol('proto.DeviceEventResponse.EventCase', null, global);
goog.exportSymbol('proto.DeviceEventResponseList', null, global);
goog.exportSymbol('proto.DeviceInfo', null, global);
goog.exportSymbol('proto.DeviceList', null, global);
goog.exportSymbol('proto.DeviceSettings', null, global);
goog.exportSymbol('proto.DeviceSettingsEventType', null, global);
goog.exportSymbol('proto.DeviceSettingsRequest', null, global);
goog.exportSymbol('proto.DeviceSettingsRequestList', null, global);
goog.exportSymbol('proto.DeviceSettingsResponse', null, global);
goog.exportSymbol('proto.DeviceSettingsSync', null, global);
goog.exportSymbol('proto.DeviceSettingsSyncCollection', null, global);
goog.exportSymbol('proto.DeviceStatus', null, global);
goog.exportSymbol('proto.DeviceStatusResponse', null, global);
goog.exportSymbol('proto.DeviceSummaryResponse', null, global);
goog.exportSymbol('proto.DeviceSummaryResponseList', null, global);
goog.exportSymbol('proto.HardwareFactoryReset', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceDto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceDto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceDto.displayName = 'proto.DeviceDto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.DeviceList.repeatedFields_, null);
};
goog.inherits(proto.DeviceList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceList.displayName = 'proto.DeviceList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceInfo.displayName = 'proto.DeviceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSettings.displayName = 'proto.DeviceSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSettingsRequest.displayName = 'proto.DeviceSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSettingsRequestList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.DeviceSettingsRequestList.repeatedFields_, null);
};
goog.inherits(proto.DeviceSettingsRequestList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSettingsRequestList.displayName = 'proto.DeviceSettingsRequestList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceStatus.displayName = 'proto.DeviceStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceStatusResponse.displayName = 'proto.DeviceStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSettingsResponse.displayName = 'proto.DeviceSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceEventResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.DeviceEventResponse.oneofGroups_);
};
goog.inherits(proto.DeviceEventResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceEventResponse.displayName = 'proto.DeviceEventResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceEventResponseList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.DeviceEventResponseList.repeatedFields_, null);
};
goog.inherits(proto.DeviceEventResponseList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceEventResponseList.displayName = 'proto.DeviceEventResponseList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSummaryResponse.displayName = 'proto.DeviceSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSummaryResponseList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.DeviceSummaryResponseList.repeatedFields_, null);
};
goog.inherits(proto.DeviceSummaryResponseList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSummaryResponseList.displayName = 'proto.DeviceSummaryResponseList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSettingsSync = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceSettingsSync, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSettingsSync.displayName = 'proto.DeviceSettingsSync';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceSettingsSyncCollection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceSettingsSyncCollection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceSettingsSyncCollection.displayName = 'proto.DeviceSettingsSyncCollection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.HardwareFactoryReset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.HardwareFactoryReset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.HardwareFactoryReset.displayName = 'proto.HardwareFactoryReset';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceDto.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceDto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceDto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceDto.toObject = function(includeInstance, msg) {
  var f, obj = {
imei: jspb.Message.getFieldWithDefault(msg, 1, ""),
serial: jspb.Message.getFieldWithDefault(msg, 2, ""),
userAccountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
model: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceDto}
 */
proto.DeviceDto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceDto;
  return proto.DeviceDto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceDto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceDto}
 */
proto.DeviceDto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImei(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserAccountId(value);
      break;
    case 4:
      var value = /** @type {!proto.DeviceRecord.Model} */ (reader.readEnum());
      msg.setModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceDto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceDto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceDto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceDto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImei();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModel();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string imei = 1;
 * @return {string}
 */
proto.DeviceDto.prototype.getImei = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceDto} returns this
 */
proto.DeviceDto.prototype.setImei = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string serial = 2;
 * @return {string}
 */
proto.DeviceDto.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceDto} returns this
 */
proto.DeviceDto.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_account_id = 3;
 * @return {string}
 */
proto.DeviceDto.prototype.getUserAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceDto} returns this
 */
proto.DeviceDto.prototype.setUserAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DeviceRecord.Model model = 4;
 * @return {!proto.DeviceRecord.Model}
 */
proto.DeviceDto.prototype.getModel = function() {
  return /** @type {!proto.DeviceRecord.Model} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.DeviceRecord.Model} value
 * @return {!proto.DeviceDto} returns this
 */
proto.DeviceDto.prototype.setModel = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.DeviceList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceList.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceList.toObject = function(includeInstance, msg) {
  var f, obj = {
devicesList: jspb.Message.toObjectList(msg.getDevicesList(),
    proto.DeviceDto.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceList}
 */
proto.DeviceList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceList;
  return proto.DeviceList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceList}
 */
proto.DeviceList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceDto;
      reader.readMessage(value,proto.DeviceDto.deserializeBinaryFromReader);
      msg.addDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.DeviceDto.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceDto devices = 1;
 * @return {!Array<!proto.DeviceDto>}
 */
proto.DeviceList.prototype.getDevicesList = function() {
  return /** @type{!Array<!proto.DeviceDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.DeviceDto, 1));
};


/**
 * @param {!Array<!proto.DeviceDto>} value
 * @return {!proto.DeviceList} returns this
*/
proto.DeviceList.prototype.setDevicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.DeviceDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.DeviceDto}
 */
proto.DeviceList.prototype.addDevices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.DeviceDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.DeviceList} returns this
 */
proto.DeviceList.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
device: (f = msg.getDevice()) && proto.DeviceDto.toObject(includeInstance, f),
iridiumAccount: (f = msg.getIridiumAccount()) && iridium_account_proto_pb.IridiumAccount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceInfo}
 */
proto.DeviceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceInfo;
  return proto.DeviceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceInfo}
 */
proto.DeviceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceDto;
      reader.readMessage(value,proto.DeviceDto.deserializeBinaryFromReader);
      msg.setDevice(value);
      break;
    case 2:
      var value = new iridium_account_proto_pb.IridiumAccount;
      reader.readMessage(value,iridium_account_proto_pb.IridiumAccount.deserializeBinaryFromReader);
      msg.setIridiumAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.DeviceDto.serializeBinaryToWriter
    );
  }
  f = message.getIridiumAccount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      iridium_account_proto_pb.IridiumAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceDto device = 1;
 * @return {?proto.DeviceDto}
 */
proto.DeviceInfo.prototype.getDevice = function() {
  return /** @type{?proto.DeviceDto} */ (
    jspb.Message.getWrapperField(this, proto.DeviceDto, 1));
};


/**
 * @param {?proto.DeviceDto|undefined} value
 * @return {!proto.DeviceInfo} returns this
*/
proto.DeviceInfo.prototype.setDevice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceInfo} returns this
 */
proto.DeviceInfo.prototype.clearDevice = function() {
  return this.setDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceInfo.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IridiumAccount iridium_account = 2;
 * @return {?proto.IridiumAccount}
 */
proto.DeviceInfo.prototype.getIridiumAccount = function() {
  return /** @type{?proto.IridiumAccount} */ (
    jspb.Message.getWrapperField(this, iridium_account_proto_pb.IridiumAccount, 2));
};


/**
 * @param {?proto.IridiumAccount|undefined} value
 * @return {!proto.DeviceInfo} returns this
*/
proto.DeviceInfo.prototype.setIridiumAccount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceInfo} returns this
 */
proto.DeviceInfo.prototype.clearIridiumAccount = function() {
  return this.setIridiumAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceInfo.prototype.hasIridiumAccount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
trackingOn: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
trackingInterval: jspb.Message.getFieldWithDefault(msg, 2, 0),
gpsInterval: jspb.Message.getFieldWithDefault(msg, 3, 0),
batteryReporting: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
sentTimestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
enableAltitudeReporting: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
enableSpeedAndCourseReporting: jspb.Message.getFieldWithDefault(msg, 7, 0),
enableBackhaul: jspb.Message.getFieldWithDefault(msg, 8, 0),
iridiumNoSleep: jspb.Message.getFieldWithDefault(msg, 9, 0),
radioMode: jspb.Message.getFieldWithDefault(msg, 10, 0),
lowSpeedFrequencyHz: jspb.Message.getFieldWithDefault(msg, 11, 0),
highSpeedFrequencyHz: jspb.Message.getFieldWithDefault(msg, 12, 0),
radioPowerMode: jspb.Message.getFieldWithDefault(msg, 13, 0),
buttonFunction: jspb.Message.getFieldWithDefault(msg, 14, 0),
meshVersionToDeploy: jspb.Message.getFieldWithDefault(msg, 15, 0),
lowSpeedDataRateParameters: (f = msg.getLowSpeedDataRateParameters()) && command_public_proto_pb.RadioDataRateParameters.toObject(includeInstance, f),
highSpeedDataRateParameters: (f = msg.getHighSpeedDataRateParameters()) && command_public_proto_pb.RadioDataRateParameters.toObject(includeInstance, f),
trackingOnOptional: jspb.Message.getFieldWithDefault(msg, 18, 0),
altitudeReportingOptional: jspb.Message.getFieldWithDefault(msg, 19, 0),
radioRegion: jspb.Message.getFieldWithDefault(msg, 20, 0),
requestId: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSettings}
 */
proto.DeviceSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSettings;
  return proto.DeviceSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSettings}
 */
proto.DeviceSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrackingOn(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrackingInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGpsInterval(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryReporting(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSentTimestamp(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAltitudeReporting(value);
      break;
    case 7:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setEnableSpeedAndCourseReporting(value);
      break;
    case 8:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setEnableBackhaul(value);
      break;
    case 9:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setIridiumNoSleep(value);
      break;
    case 10:
      var value = /** @type {!proto.RadioMode} */ (reader.readEnum());
      msg.setRadioMode(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLowSpeedFrequencyHz(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHighSpeedFrequencyHz(value);
      break;
    case 13:
      var value = /** @type {!proto.RadioPowerMode} */ (reader.readEnum());
      msg.setRadioPowerMode(value);
      break;
    case 14:
      var value = /** @type {!proto.ButtonFunction} */ (reader.readEnum());
      msg.setButtonFunction(value);
      break;
    case 15:
      var value = /** @type {!proto.MeshVersion} */ (reader.readEnum());
      msg.setMeshVersionToDeploy(value);
      break;
    case 16:
      var value = new command_public_proto_pb.RadioDataRateParameters;
      reader.readMessage(value,command_public_proto_pb.RadioDataRateParameters.deserializeBinaryFromReader);
      msg.setLowSpeedDataRateParameters(value);
      break;
    case 17:
      var value = new command_public_proto_pb.RadioDataRateParameters;
      reader.readMessage(value,command_public_proto_pb.RadioDataRateParameters.deserializeBinaryFromReader);
      msg.setHighSpeedDataRateParameters(value);
      break;
    case 18:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setTrackingOnOptional(value);
      break;
    case 19:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setAltitudeReportingOptional(value);
      break;
    case 20:
      var value = /** @type {!proto.RadioRegion} */ (reader.readEnum());
      msg.setRadioRegion(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrackingOn();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTrackingInterval();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getGpsInterval();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getBatteryReporting();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSentTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getEnableAltitudeReporting();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getEnableSpeedAndCourseReporting();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getEnableBackhaul();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getIridiumNoSleep();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getRadioMode();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getLowSpeedFrequencyHz();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getHighSpeedFrequencyHz();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getRadioPowerMode();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getButtonFunction();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getMeshVersionToDeploy();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getLowSpeedDataRateParameters();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      command_public_proto_pb.RadioDataRateParameters.serializeBinaryToWriter
    );
  }
  f = message.getHighSpeedDataRateParameters();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      command_public_proto_pb.RadioDataRateParameters.serializeBinaryToWriter
    );
  }
  f = message.getTrackingOnOptional();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getAltitudeReportingOptional();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getRadioRegion();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeUint64(
      21,
      f
    );
  }
};


/**
 * optional bool tracking_on = 1;
 * @return {boolean}
 */
proto.DeviceSettings.prototype.getTrackingOn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setTrackingOn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional uint32 tracking_interval = 2;
 * @return {number}
 */
proto.DeviceSettings.prototype.getTrackingInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setTrackingInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 gps_interval = 3;
 * @return {number}
 */
proto.DeviceSettings.prototype.getGpsInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setGpsInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool battery_reporting = 4;
 * @return {boolean}
 */
proto.DeviceSettings.prototype.getBatteryReporting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setBatteryReporting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional fixed32 sent_timestamp = 5;
 * @return {number}
 */
proto.DeviceSettings.prototype.getSentTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setSentTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool enable_altitude_reporting = 6;
 * @return {boolean}
 */
proto.DeviceSettings.prototype.getEnableAltitudeReporting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setEnableAltitudeReporting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional OptionalBool enable_speed_and_course_reporting = 7;
 * @return {!proto.OptionalBool}
 */
proto.DeviceSettings.prototype.getEnableSpeedAndCourseReporting = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setEnableSpeedAndCourseReporting = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional OptionalBool enable_backhaul = 8;
 * @return {!proto.OptionalBool}
 */
proto.DeviceSettings.prototype.getEnableBackhaul = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setEnableBackhaul = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional OptionalBool iridium_no_sleep = 9;
 * @return {!proto.OptionalBool}
 */
proto.DeviceSettings.prototype.getIridiumNoSleep = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setIridiumNoSleep = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional RadioMode radio_mode = 10;
 * @return {!proto.RadioMode}
 */
proto.DeviceSettings.prototype.getRadioMode = function() {
  return /** @type {!proto.RadioMode} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.RadioMode} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setRadioMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional uint32 low_speed_frequency_hz = 11;
 * @return {number}
 */
proto.DeviceSettings.prototype.getLowSpeedFrequencyHz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setLowSpeedFrequencyHz = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 high_speed_frequency_hz = 12;
 * @return {number}
 */
proto.DeviceSettings.prototype.getHighSpeedFrequencyHz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setHighSpeedFrequencyHz = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional RadioPowerMode radio_power_mode = 13;
 * @return {!proto.RadioPowerMode}
 */
proto.DeviceSettings.prototype.getRadioPowerMode = function() {
  return /** @type {!proto.RadioPowerMode} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.RadioPowerMode} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setRadioPowerMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional ButtonFunction button_function = 14;
 * @return {!proto.ButtonFunction}
 */
proto.DeviceSettings.prototype.getButtonFunction = function() {
  return /** @type {!proto.ButtonFunction} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.ButtonFunction} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setButtonFunction = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional MeshVersion mesh_version_to_deploy = 15;
 * @return {!proto.MeshVersion}
 */
proto.DeviceSettings.prototype.getMeshVersionToDeploy = function() {
  return /** @type {!proto.MeshVersion} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.MeshVersion} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setMeshVersionToDeploy = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional RadioDataRateParameters low_speed_data_rate_parameters = 16;
 * @return {?proto.RadioDataRateParameters}
 */
proto.DeviceSettings.prototype.getLowSpeedDataRateParameters = function() {
  return /** @type{?proto.RadioDataRateParameters} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.RadioDataRateParameters, 16));
};


/**
 * @param {?proto.RadioDataRateParameters|undefined} value
 * @return {!proto.DeviceSettings} returns this
*/
proto.DeviceSettings.prototype.setLowSpeedDataRateParameters = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.clearLowSpeedDataRateParameters = function() {
  return this.setLowSpeedDataRateParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSettings.prototype.hasLowSpeedDataRateParameters = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional RadioDataRateParameters high_speed_data_rate_parameters = 17;
 * @return {?proto.RadioDataRateParameters}
 */
proto.DeviceSettings.prototype.getHighSpeedDataRateParameters = function() {
  return /** @type{?proto.RadioDataRateParameters} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.RadioDataRateParameters, 17));
};


/**
 * @param {?proto.RadioDataRateParameters|undefined} value
 * @return {!proto.DeviceSettings} returns this
*/
proto.DeviceSettings.prototype.setHighSpeedDataRateParameters = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.clearHighSpeedDataRateParameters = function() {
  return this.setHighSpeedDataRateParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSettings.prototype.hasHighSpeedDataRateParameters = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional OptionalBool tracking_on_optional = 18;
 * @return {!proto.OptionalBool}
 */
proto.DeviceSettings.prototype.getTrackingOnOptional = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setTrackingOnOptional = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional OptionalBool altitude_reporting_optional = 19;
 * @return {!proto.OptionalBool}
 */
proto.DeviceSettings.prototype.getAltitudeReportingOptional = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setAltitudeReportingOptional = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional RadioRegion radio_region = 20;
 * @return {!proto.RadioRegion}
 */
proto.DeviceSettings.prototype.getRadioRegion = function() {
  return /** @type {!proto.RadioRegion} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.RadioRegion} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setRadioRegion = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional uint64 request_id = 21;
 * @return {number}
 */
proto.DeviceSettings.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettings} returns this
 */
proto.DeviceSettings.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
settings: (f = msg.getSettings()) && proto.DeviceSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSettingsRequest}
 */
proto.DeviceSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSettingsRequest;
  return proto.DeviceSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSettingsRequest}
 */
proto.DeviceSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = new proto.DeviceSettings;
      reader.readMessage(value,proto.DeviceSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.DeviceSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.DeviceSettingsRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceSettingsRequest} returns this
 */
proto.DeviceSettingsRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceSettings settings = 2;
 * @return {?proto.DeviceSettings}
 */
proto.DeviceSettingsRequest.prototype.getSettings = function() {
  return /** @type{?proto.DeviceSettings} */ (
    jspb.Message.getWrapperField(this, proto.DeviceSettings, 2));
};


/**
 * @param {?proto.DeviceSettings|undefined} value
 * @return {!proto.DeviceSettingsRequest} returns this
*/
proto.DeviceSettingsRequest.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSettingsRequest} returns this
 */
proto.DeviceSettingsRequest.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSettingsRequest.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.DeviceSettingsRequestList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSettingsRequestList.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSettingsRequestList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSettingsRequestList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsRequestList.toObject = function(includeInstance, msg) {
  var f, obj = {
requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.DeviceSettingsRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSettingsRequestList}
 */
proto.DeviceSettingsRequestList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSettingsRequestList;
  return proto.DeviceSettingsRequestList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSettingsRequestList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSettingsRequestList}
 */
proto.DeviceSettingsRequestList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceSettingsRequest;
      reader.readMessage(value,proto.DeviceSettingsRequest.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSettingsRequestList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSettingsRequestList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSettingsRequestList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsRequestList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.DeviceSettingsRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceSettingsRequest requests = 1;
 * @return {!Array<!proto.DeviceSettingsRequest>}
 */
proto.DeviceSettingsRequestList.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.DeviceSettingsRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.DeviceSettingsRequest, 1));
};


/**
 * @param {!Array<!proto.DeviceSettingsRequest>} value
 * @return {!proto.DeviceSettingsRequestList} returns this
*/
proto.DeviceSettingsRequestList.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.DeviceSettingsRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.DeviceSettingsRequest}
 */
proto.DeviceSettingsRequestList.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.DeviceSettingsRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.DeviceSettingsRequestList} returns this
 */
proto.DeviceSettingsRequestList.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
battery: jspb.Message.getFieldWithDefault(msg, 1, 0),
firmwareversion: jspb.Message.getFieldWithDefault(msg, 2, 0),
imei: jspb.Message.getFieldWithDefault(msg, 3, 0),
hardwareFlavor: jspb.Message.getFieldWithDefault(msg, 4, 0),
firmwareFlavor: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceStatus}
 */
proto.DeviceStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceStatus;
  return proto.DeviceStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceStatus}
 */
proto.DeviceStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBattery(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFirmwareversion(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setImei(value);
      break;
    case 4:
      var value = /** @type {!proto.HardwareFlavor} */ (reader.readEnum());
      msg.setHardwareFlavor(value);
      break;
    case 5:
      var value = /** @type {!proto.FirmwareFlavor} */ (reader.readEnum());
      msg.setFirmwareFlavor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBattery();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFirmwareversion();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getImei();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getHardwareFlavor();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getFirmwareFlavor();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional uint32 battery = 1;
 * @return {number}
 */
proto.DeviceStatus.prototype.getBattery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceStatus} returns this
 */
proto.DeviceStatus.prototype.setBattery = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 firmwareVersion = 2;
 * @return {number}
 */
proto.DeviceStatus.prototype.getFirmwareversion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceStatus} returns this
 */
proto.DeviceStatus.prototype.setFirmwareversion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 imei = 3;
 * @return {number}
 */
proto.DeviceStatus.prototype.getImei = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceStatus} returns this
 */
proto.DeviceStatus.prototype.setImei = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional HardwareFlavor hardware_flavor = 4;
 * @return {!proto.HardwareFlavor}
 */
proto.DeviceStatus.prototype.getHardwareFlavor = function() {
  return /** @type {!proto.HardwareFlavor} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.HardwareFlavor} value
 * @return {!proto.DeviceStatus} returns this
 */
proto.DeviceStatus.prototype.setHardwareFlavor = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional FirmwareFlavor firmware_flavor = 5;
 * @return {!proto.FirmwareFlavor}
 */
proto.DeviceStatus.prototype.getFirmwareFlavor = function() {
  return /** @type {!proto.FirmwareFlavor} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.FirmwareFlavor} value
 * @return {!proto.DeviceStatus} returns this
 */
proto.DeviceStatus.prototype.setFirmwareFlavor = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: (f = msg.getTimestamp()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
serial: jspb.Message.getFieldWithDefault(msg, 2, ""),
battery: jspb.Message.getFieldWithDefault(msg, 3, 0),
firmwareversion: jspb.Message.getFieldWithDefault(msg, 4, ""),
peripherals: (f = msg.getPeripherals()) && peripheral_proto_pb.PeripheralResponseList.toObject(includeInstance, f),
lastHeartbeat: (f = msg.getLastHeartbeat()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
trackingOn: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceStatusResponse}
 */
proto.DeviceStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceStatusResponse;
  return proto.DeviceStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceStatusResponse}
 */
proto.DeviceStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBattery(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmwareversion(value);
      break;
    case 5:
      var value = new peripheral_proto_pb.PeripheralResponseList;
      reader.readMessage(value,peripheral_proto_pb.PeripheralResponseList.deserializeBinaryFromReader);
      msg.setPeripherals(value);
      break;
    case 6:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastHeartbeat(value);
      break;
    case 7:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setTrackingOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBattery();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getFirmwareversion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPeripherals();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      peripheral_proto_pb.PeripheralResponseList.serializeBinaryToWriter
    );
  }
  f = message.getLastHeartbeat();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTrackingOn();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional Timestamp timestamp = 1;
 * @return {?proto.Timestamp}
 */
proto.DeviceStatusResponse.prototype.getTimestamp = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 1));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.DeviceStatusResponse} returns this
*/
proto.DeviceStatusResponse.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceStatusResponse.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string serial = 2;
 * @return {string}
 */
proto.DeviceStatusResponse.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 battery = 3;
 * @return {number}
 */
proto.DeviceStatusResponse.prototype.getBattery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.setBattery = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string firmwareVersion = 4;
 * @return {string}
 */
proto.DeviceStatusResponse.prototype.getFirmwareversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.setFirmwareversion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional PeripheralResponseList peripherals = 5;
 * @return {?proto.PeripheralResponseList}
 */
proto.DeviceStatusResponse.prototype.getPeripherals = function() {
  return /** @type{?proto.PeripheralResponseList} */ (
    jspb.Message.getWrapperField(this, peripheral_proto_pb.PeripheralResponseList, 5));
};


/**
 * @param {?proto.PeripheralResponseList|undefined} value
 * @return {!proto.DeviceStatusResponse} returns this
*/
proto.DeviceStatusResponse.prototype.setPeripherals = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.clearPeripherals = function() {
  return this.setPeripherals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceStatusResponse.prototype.hasPeripherals = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Timestamp last_heartbeat = 6;
 * @return {?proto.Timestamp}
 */
proto.DeviceStatusResponse.prototype.getLastHeartbeat = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 6));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.DeviceStatusResponse} returns this
*/
proto.DeviceStatusResponse.prototype.setLastHeartbeat = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.clearLastHeartbeat = function() {
  return this.setLastHeartbeat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceStatusResponse.prototype.hasLastHeartbeat = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional OptionalBool tracking_on = 7;
 * @return {!proto.OptionalBool}
 */
proto.DeviceStatusResponse.prototype.getTrackingOn = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.DeviceStatusResponse} returns this
 */
proto.DeviceStatusResponse.prototype.setTrackingOn = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: (f = msg.getTimestamp()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
serial: jspb.Message.getFieldWithDefault(msg, 2, ""),
settings: (f = msg.getSettings()) && proto.DeviceSettings.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 4, 0),
settingsCommand: (f = msg.getSettingsCommand()) && command_proto_pb.SettingsCommand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSettingsResponse}
 */
proto.DeviceSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSettingsResponse;
  return proto.DeviceSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSettingsResponse}
 */
proto.DeviceSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 3:
      var value = new proto.DeviceSettings;
      reader.readMessage(value,proto.DeviceSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 4:
      var value = /** @type {!proto.DeviceSettingsEventType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = new command_proto_pb.SettingsCommand;
      reader.readMessage(value,command_proto_pb.SettingsCommand.deserializeBinaryFromReader);
      msg.setSettingsCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.DeviceSettings.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSettingsCommand();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      command_proto_pb.SettingsCommand.serializeBinaryToWriter
    );
  }
};


/**
 * optional Timestamp timestamp = 1;
 * @return {?proto.Timestamp}
 */
proto.DeviceSettingsResponse.prototype.getTimestamp = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 1));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.DeviceSettingsResponse} returns this
*/
proto.DeviceSettingsResponse.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSettingsResponse} returns this
 */
proto.DeviceSettingsResponse.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSettingsResponse.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string serial = 2;
 * @return {string}
 */
proto.DeviceSettingsResponse.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceSettingsResponse} returns this
 */
proto.DeviceSettingsResponse.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional DeviceSettings settings = 3;
 * @return {?proto.DeviceSettings}
 */
proto.DeviceSettingsResponse.prototype.getSettings = function() {
  return /** @type{?proto.DeviceSettings} */ (
    jspb.Message.getWrapperField(this, proto.DeviceSettings, 3));
};


/**
 * @param {?proto.DeviceSettings|undefined} value
 * @return {!proto.DeviceSettingsResponse} returns this
*/
proto.DeviceSettingsResponse.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSettingsResponse} returns this
 */
proto.DeviceSettingsResponse.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSettingsResponse.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DeviceSettingsEventType type = 4;
 * @return {!proto.DeviceSettingsEventType}
 */
proto.DeviceSettingsResponse.prototype.getType = function() {
  return /** @type {!proto.DeviceSettingsEventType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.DeviceSettingsEventType} value
 * @return {!proto.DeviceSettingsResponse} returns this
 */
proto.DeviceSettingsResponse.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional SettingsCommand settings_command = 5;
 * @return {?proto.SettingsCommand}
 */
proto.DeviceSettingsResponse.prototype.getSettingsCommand = function() {
  return /** @type{?proto.SettingsCommand} */ (
    jspb.Message.getWrapperField(this, command_proto_pb.SettingsCommand, 5));
};


/**
 * @param {?proto.SettingsCommand|undefined} value
 * @return {!proto.DeviceSettingsResponse} returns this
*/
proto.DeviceSettingsResponse.prototype.setSettingsCommand = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSettingsResponse} returns this
 */
proto.DeviceSettingsResponse.prototype.clearSettingsCommand = function() {
  return this.setSettingsCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSettingsResponse.prototype.hasSettingsCommand = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.DeviceEventResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.DeviceEventResponse.EventCase = {
  EVENT_NOT_SET: 0,
  STATUS: 1,
  SETTINGS: 2
};

/**
 * @return {proto.DeviceEventResponse.EventCase}
 */
proto.DeviceEventResponse.prototype.getEventCase = function() {
  return /** @type {proto.DeviceEventResponse.EventCase} */(jspb.Message.computeOneofCase(this, proto.DeviceEventResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceEventResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceEventResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceEventResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
status: (f = msg.getStatus()) && proto.DeviceStatusResponse.toObject(includeInstance, f),
settings: (f = msg.getSettings()) && proto.DeviceSettingsResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceEventResponse}
 */
proto.DeviceEventResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceEventResponse;
  return proto.DeviceEventResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceEventResponse}
 */
proto.DeviceEventResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceStatusResponse;
      reader.readMessage(value,proto.DeviceStatusResponse.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 2:
      var value = new proto.DeviceSettingsResponse;
      reader.readMessage(value,proto.DeviceSettingsResponse.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceEventResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceEventResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceEventResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.DeviceStatusResponse.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.DeviceSettingsResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceStatusResponse status = 1;
 * @return {?proto.DeviceStatusResponse}
 */
proto.DeviceEventResponse.prototype.getStatus = function() {
  return /** @type{?proto.DeviceStatusResponse} */ (
    jspb.Message.getWrapperField(this, proto.DeviceStatusResponse, 1));
};


/**
 * @param {?proto.DeviceStatusResponse|undefined} value
 * @return {!proto.DeviceEventResponse} returns this
*/
proto.DeviceEventResponse.prototype.setStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.DeviceEventResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceEventResponse} returns this
 */
proto.DeviceEventResponse.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceEventResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DeviceSettingsResponse settings = 2;
 * @return {?proto.DeviceSettingsResponse}
 */
proto.DeviceEventResponse.prototype.getSettings = function() {
  return /** @type{?proto.DeviceSettingsResponse} */ (
    jspb.Message.getWrapperField(this, proto.DeviceSettingsResponse, 2));
};


/**
 * @param {?proto.DeviceSettingsResponse|undefined} value
 * @return {!proto.DeviceEventResponse} returns this
*/
proto.DeviceEventResponse.prototype.setSettings = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.DeviceEventResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceEventResponse} returns this
 */
proto.DeviceEventResponse.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceEventResponse.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.DeviceEventResponseList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceEventResponseList.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceEventResponseList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceEventResponseList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceEventResponseList.toObject = function(includeInstance, msg) {
  var f, obj = {
eventsList: jspb.Message.toObjectList(msg.getEventsList(),
    proto.DeviceEventResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceEventResponseList}
 */
proto.DeviceEventResponseList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceEventResponseList;
  return proto.DeviceEventResponseList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceEventResponseList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceEventResponseList}
 */
proto.DeviceEventResponseList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceEventResponse;
      reader.readMessage(value,proto.DeviceEventResponse.deserializeBinaryFromReader);
      msg.addEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceEventResponseList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceEventResponseList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceEventResponseList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceEventResponseList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.DeviceEventResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceEventResponse events = 1;
 * @return {!Array<!proto.DeviceEventResponse>}
 */
proto.DeviceEventResponseList.prototype.getEventsList = function() {
  return /** @type{!Array<!proto.DeviceEventResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.DeviceEventResponse, 1));
};


/**
 * @param {!Array<!proto.DeviceEventResponse>} value
 * @return {!proto.DeviceEventResponseList} returns this
*/
proto.DeviceEventResponseList.prototype.setEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.DeviceEventResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.DeviceEventResponse}
 */
proto.DeviceEventResponseList.prototype.addEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.DeviceEventResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.DeviceEventResponseList} returns this
 */
proto.DeviceEventResponseList.prototype.clearEventsList = function() {
  return this.setEventsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
status: (f = msg.getStatus()) && proto.DeviceStatusResponse.toObject(includeInstance, f),
settings: (f = msg.getSettings()) && proto.DeviceSettingsResponse.toObject(includeInstance, f),
serial: jspb.Message.getFieldWithDefault(msg, 3, ""),
user: (f = msg.getUser()) && user_proto_pb.UserResponse.toObject(includeInstance, f),
userId: jspb.Message.getFieldWithDefault(msg, 5, ""),
userIdentityId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSummaryResponse}
 */
proto.DeviceSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSummaryResponse;
  return proto.DeviceSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSummaryResponse}
 */
proto.DeviceSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceStatusResponse;
      reader.readMessage(value,proto.DeviceStatusResponse.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 2:
      var value = new proto.DeviceSettingsResponse;
      reader.readMessage(value,proto.DeviceSettingsResponse.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 4:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserIdentityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.DeviceStatusResponse.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.DeviceSettingsResponse.serializeBinaryToWriter
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserIdentityId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional DeviceStatusResponse status = 1;
 * @return {?proto.DeviceStatusResponse}
 */
proto.DeviceSummaryResponse.prototype.getStatus = function() {
  return /** @type{?proto.DeviceStatusResponse} */ (
    jspb.Message.getWrapperField(this, proto.DeviceStatusResponse, 1));
};


/**
 * @param {?proto.DeviceStatusResponse|undefined} value
 * @return {!proto.DeviceSummaryResponse} returns this
*/
proto.DeviceSummaryResponse.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSummaryResponse} returns this
 */
proto.DeviceSummaryResponse.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSummaryResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DeviceSettingsResponse settings = 2;
 * @return {?proto.DeviceSettingsResponse}
 */
proto.DeviceSummaryResponse.prototype.getSettings = function() {
  return /** @type{?proto.DeviceSettingsResponse} */ (
    jspb.Message.getWrapperField(this, proto.DeviceSettingsResponse, 2));
};


/**
 * @param {?proto.DeviceSettingsResponse|undefined} value
 * @return {!proto.DeviceSummaryResponse} returns this
*/
proto.DeviceSummaryResponse.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSummaryResponse} returns this
 */
proto.DeviceSummaryResponse.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSummaryResponse.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string serial = 3;
 * @return {string}
 */
proto.DeviceSummaryResponse.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceSummaryResponse} returns this
 */
proto.DeviceSummaryResponse.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional UserResponse user = 4;
 * @return {?proto.UserResponse}
 */
proto.DeviceSummaryResponse.prototype.getUser = function() {
  return /** @type{?proto.UserResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.UserResponse, 4));
};


/**
 * @param {?proto.UserResponse|undefined} value
 * @return {!proto.DeviceSummaryResponse} returns this
*/
proto.DeviceSummaryResponse.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DeviceSummaryResponse} returns this
 */
proto.DeviceSummaryResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DeviceSummaryResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string user_id = 5;
 * @return {string}
 */
proto.DeviceSummaryResponse.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceSummaryResponse} returns this
 */
proto.DeviceSummaryResponse.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string user_identity_id = 6;
 * @return {string}
 */
proto.DeviceSummaryResponse.prototype.getUserIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceSummaryResponse} returns this
 */
proto.DeviceSummaryResponse.prototype.setUserIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.DeviceSummaryResponseList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSummaryResponseList.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSummaryResponseList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSummaryResponseList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSummaryResponseList.toObject = function(includeInstance, msg) {
  var f, obj = {
devicesList: jspb.Message.toObjectList(msg.getDevicesList(),
    proto.DeviceSummaryResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSummaryResponseList}
 */
proto.DeviceSummaryResponseList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSummaryResponseList;
  return proto.DeviceSummaryResponseList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSummaryResponseList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSummaryResponseList}
 */
proto.DeviceSummaryResponseList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.DeviceSummaryResponse;
      reader.readMessage(value,proto.DeviceSummaryResponse.deserializeBinaryFromReader);
      msg.addDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSummaryResponseList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSummaryResponseList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSummaryResponseList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSummaryResponseList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.DeviceSummaryResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceSummaryResponse devices = 1;
 * @return {!Array<!proto.DeviceSummaryResponse>}
 */
proto.DeviceSummaryResponseList.prototype.getDevicesList = function() {
  return /** @type{!Array<!proto.DeviceSummaryResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.DeviceSummaryResponse, 1));
};


/**
 * @param {!Array<!proto.DeviceSummaryResponse>} value
 * @return {!proto.DeviceSummaryResponseList} returns this
*/
proto.DeviceSummaryResponseList.prototype.setDevicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.DeviceSummaryResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.DeviceSummaryResponse}
 */
proto.DeviceSummaryResponseList.prototype.addDevices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.DeviceSummaryResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.DeviceSummaryResponseList} returns this
 */
proto.DeviceSummaryResponseList.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSettingsSync.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSettingsSync.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSettingsSync} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsSync.toObject = function(includeInstance, msg) {
  var f, obj = {
settings: msg.getSettings_asB64(),
trackingOn: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
imei: jspb.Message.getFieldWithDefault(msg, 3, 0),
requestId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSettingsSync}
 */
proto.DeviceSettingsSync.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSettingsSync;
  return proto.DeviceSettingsSync.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSettingsSync} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSettingsSync}
 */
proto.DeviceSettingsSync.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSettings(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrackingOn(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setImei(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSettingsSync.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSettingsSync.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSettingsSync} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsSync.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettings_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getTrackingOn();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getImei();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional bytes settings = 1;
 * @return {!(string|Uint8Array)}
 */
proto.DeviceSettingsSync.prototype.getSettings = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes settings = 1;
 * This is a type-conversion wrapper around `getSettings()`
 * @return {string}
 */
proto.DeviceSettingsSync.prototype.getSettings_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSettings()));
};


/**
 * optional bytes settings = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSettings()`
 * @return {!Uint8Array}
 */
proto.DeviceSettingsSync.prototype.getSettings_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSettings()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DeviceSettingsSync} returns this
 */
proto.DeviceSettingsSync.prototype.setSettings = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bool tracking_on = 2;
 * @return {boolean}
 */
proto.DeviceSettingsSync.prototype.getTrackingOn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.DeviceSettingsSync} returns this
 */
proto.DeviceSettingsSync.prototype.setTrackingOn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional uint64 imei = 3;
 * @return {number}
 */
proto.DeviceSettingsSync.prototype.getImei = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettingsSync} returns this
 */
proto.DeviceSettingsSync.prototype.setImei = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 request_id = 4;
 * @return {number}
 */
proto.DeviceSettingsSync.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettingsSync} returns this
 */
proto.DeviceSettingsSync.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceSettingsSyncCollection.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceSettingsSyncCollection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceSettingsSyncCollection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsSyncCollection.toObject = function(includeInstance, msg) {
  var f, obj = {
baseImei: jspb.Message.getFieldWithDefault(msg, 1, 0),
baseRequestId: jspb.Message.getFieldWithDefault(msg, 2, 0),
baseAppliedTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
settingsSyncDeltas: msg.getSettingsSyncDeltas_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceSettingsSyncCollection}
 */
proto.DeviceSettingsSyncCollection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceSettingsSyncCollection;
  return proto.DeviceSettingsSyncCollection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceSettingsSyncCollection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceSettingsSyncCollection}
 */
proto.DeviceSettingsSyncCollection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBaseImei(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBaseRequestId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setBaseAppliedTime(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSettingsSyncDeltas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceSettingsSyncCollection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceSettingsSyncCollection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceSettingsSyncCollection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceSettingsSyncCollection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaseImei();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getBaseRequestId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBaseAppliedTime();
  if (f !== 0) {
    writer.writeFixed32(
      3,
      f
    );
  }
  f = message.getSettingsSyncDeltas_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional uint64 base_imei = 1;
 * @return {number}
 */
proto.DeviceSettingsSyncCollection.prototype.getBaseImei = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettingsSyncCollection} returns this
 */
proto.DeviceSettingsSyncCollection.prototype.setBaseImei = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 base_request_id = 2;
 * @return {number}
 */
proto.DeviceSettingsSyncCollection.prototype.getBaseRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettingsSyncCollection} returns this
 */
proto.DeviceSettingsSyncCollection.prototype.setBaseRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional fixed32 base_applied_time = 3;
 * @return {number}
 */
proto.DeviceSettingsSyncCollection.prototype.getBaseAppliedTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceSettingsSyncCollection} returns this
 */
proto.DeviceSettingsSyncCollection.prototype.setBaseAppliedTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes settings_sync_deltas = 4;
 * @return {!(string|Uint8Array)}
 */
proto.DeviceSettingsSyncCollection.prototype.getSettingsSyncDeltas = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes settings_sync_deltas = 4;
 * This is a type-conversion wrapper around `getSettingsSyncDeltas()`
 * @return {string}
 */
proto.DeviceSettingsSyncCollection.prototype.getSettingsSyncDeltas_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSettingsSyncDeltas()));
};


/**
 * optional bytes settings_sync_deltas = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSettingsSyncDeltas()`
 * @return {!Uint8Array}
 */
proto.DeviceSettingsSyncCollection.prototype.getSettingsSyncDeltas_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSettingsSyncDeltas()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DeviceSettingsSyncCollection} returns this
 */
proto.DeviceSettingsSyncCollection.prototype.setSettingsSyncDeltas = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.HardwareFactoryReset.prototype.toObject = function(opt_includeInstance) {
  return proto.HardwareFactoryReset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.HardwareFactoryReset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.HardwareFactoryReset.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.HardwareFactoryReset}
 */
proto.HardwareFactoryReset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.HardwareFactoryReset;
  return proto.HardwareFactoryReset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.HardwareFactoryReset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.HardwareFactoryReset}
 */
proto.HardwareFactoryReset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.HardwareFactoryReset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.HardwareFactoryReset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.HardwareFactoryReset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.HardwareFactoryReset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.DeviceSettingsEventType = {
  SETTINGSUPDATED: 0,
  SETTINGSAPPLIED: 1,
  SETTINGSCOMMANDAPPLIED: 2
};

goog.object.extend(exports, proto);
